import { apiClient } from "@/lib/api";
import { fetchAllPages } from "@/lib/fetchAllPages";
import type { SellerAccount, SellerAccountCreate } from "@/types";

/** Backend cap: GET /sellers `limit` le=100. */
const SELLERS_PAGE_SIZE = 100;

export const sellerAccountService = {
  create: async (data: SellerAccountCreate): Promise<SellerAccount> => {
    const response = await apiClient.post<SellerAccount>("/sellers", data);
    return response.data;
  },

  getAll: (): Promise<SellerAccount[]> =>
    fetchAllPages(async (page) => {
      const response = await apiClient.get<SellerAccount[]>("/sellers", {
        params: page,
      });
      return response.data;
    }, SELLERS_PAGE_SIZE),
};
